import React from "react";

import { Action, Category } from "@/constants/events";
import { PRODUCT_CATEGORY_NAMES } from "@/constants/products";
import { useEventTracker } from "@/hooks/useEventTracker";

import Coin from "@/components/Coin";

type Props = {
  className?: string;
  title?: string;
};

const ProductCoinList: React.FC<Props> = ({ className, title }) => {
  const { publishEvent } = useEventTracker();

  const coinCategories = Object.keys(PRODUCT_CATEGORY_NAMES);

  return (
    <div className={className}>
      {title && <h2 className="heading--m font-extrabold mb-md">{title}</h2>}
      <div className="overflow-x-auto">
        <ul data-testid="coin-list" className="flex gap-lg">
          {coinCategories.map((category) => (
            <Coin
              key={category}
              href={PRODUCT_CATEGORY_NAMES[category].path}
              onClick={() => {
                publishEvent({
                  action: Action.click,
                  category: Category.productCategoryCoinFilter,
                  label: PRODUCT_CATEGORY_NAMES[category].label,
                });
              }}
              title={PRODUCT_CATEGORY_NAMES[category].label}
              dataTestId={`${category}-products-category`}
              iconFilePath={`coinList/${PRODUCT_CATEGORY_NAMES[category].icon}.svg`}
            />
          ))}
        </ul>
      </div>
    </div>
  );
};

export default ProductCoinList;
